
module.exports = {


    // 个人学习系统班
    personalLearnClass: {
        title: '個人学習システムクラスコース',
        info1: '企業戦略・リーダーシップの向上にフォーカスした、管理能力の体系的な向上を目指す企業リーダー・管理職のための「エグゼクティブプログラム」「エリートプログラム」「キャピタルプログラム」の3つの体系的な長期コース。実践モデルツールと効果的なソリューションと合わせ、トレーニー企業の長期的・安定的な発展を支援します。',
        info2: '',
        info3: '',
        projectList: {
            item1: {
                projectText: {
                    title: 'エグゼクティブプログラム',
                    info: '個人的能力の向上を目指す企業エグゼクティブ',
                },
                projectInfo: {
                    title1: '自己認識を迅速に高め、企業',
                    title2: 'の長期的・安定的発展を推進',
                }
            },
            item2: {
                projectText: {
                    title: 'エリートプログラム',
                    info: 'エグゼクティブの補佐役となることを目指す企業 上級管理職',
                },
                projectInfo: {
                    title1: 'ビジネスのプロから管理のエキスパートまで、',
                    title2: '個人的成功からチームとしての成功まで',
                }
            },
            item3: {
                projectText: {
                    title: 'キャピタルプログラム',
                    info: '企業の資本的拡大のビジョンを持つエグゼクティブ',
                },
                projectInfo: {
                    title1: '資本運用実践能力を向上させ',
                    title2: '資本とセグメントリソースを効果的に連携させる',
                }
            },
        },
        table: {
            header: {
                head1: 'プログラム略称',
                head2: 'エグゼクティブプログラム',
                head3: 'エリートプログラム',
                head4: 'キャピタルプログラム',
            },
            data: [
                {
                    head1: 'プログラム正式名',
                    head2: 'ボスム・エグゼクティブクラス',
                    head3: 'ビジネスエリート・アクション・ブレークスルートレーニングキャンプ',
                    head4: '企業資本運用実践プログラム',
                },
                {
                    head1: '対象者',
                    head2: '企業創業者',
                    head3: '企業上級管理職',
                    head4: '企業創業者',
                },
                {
                    head1: 'ペインポイント',
                    head2: ["1.企業がなかなか成長しない", "2.経営管理がうまくいかない", "3.効果的なリソースがない",],
                    head3: ["1.個人的業務の達成感に欠ける", "2.チームにまとまりがなく、連携できない", "3.組織パフォーマンスを達成できない",],
                    head4: ["1.資本運用上の盲点がある", "2.融資チャネルに乏しい", "3.社の財務・税務が標準化されていない", "4.トップダウン構造が適切でない",],
                },
                {
                    head1: 'コース目標',
                    head2: ['エグゼクティブの3つのコアコンピタンスの向上', '—戦略・運用・リーダーシップ'],
                    head3: ["1.企業トップの補佐役となる", "2.チームをやる気にさせ、効率的に運用する", "3.プロセス管理を実現する",],
                    head4: ["1.資本運用能力を向上させる", "2.リソースマッチングプラットフォームを構築する", "3.適切なガバナンスを強化する", "4.資本運用の転換・高度化を実現する",],
                },
                {
                    head1: 'コース内容',
                    head2: ["「7ステップ戦略—持続的成長を促す」", "「ビジネスモデル・イノベーション—新たな収益源を探す」", "「経営管理—戦略の実行を加速する」", "「ビッグファイナンシャル・シンキング—コスト削減・効率化のデータ管理」", "「販売管理のパスワード—勝てる営業チームを作る」", "「人材戦略—企業パフォーマンスのブレークスルーを支える」", "「Win-Winのリーダーシップ—組織とチームの互恵関係を築く」",],
                    head3: ["1.自己実現を果たす ", "「管理職の役割定義と認識」 ", "「パブリック・スピーキングと効果的なコミュニケーション」 ", "2.成果をあげる ", "「戦略の実行と目標の管理」",],
                    head4: ["1.キャピタル・シンキング ", "「アントレプレナーのキャピタル・シンキングと投融資戦略」 ", "「キャピタルゲーム・クラスチーム構築トレーニングキャンプ」 ", "2.ビジネスデザイン ", "「ビジネスのベーシックロジックとモデルのイノベーション」 ", "3.適切なガバナンス ", "「財務分析とビジネスバリュー」 ", "「ガバナンスとトップダウン設計」 ", "「企業株主構成設計とインセンティブ」 ", "4.産業と金融の連携 「革新的融資戦略」 ", "「企業バリューの評価」 ", "「プライベート・エクイティ」",],
                },
                {
                    head1: '受講期間',
                    head2: '10ヶ月',
                    head3: '10个月',
                    head4: '1年',
                },
                {
                    head1: '受講場所',
                    head2: '全国',
                    head3: '全国',
                    head4: '全国',
                },
                {
                    head1: '受講料金',
                    head2: '9.9万元',
                    head3: '4.28万元',
                    head4: '9.9万元',
                },
                {
                    head1: '資料ダウンロード',
                    head2: '左にスライド してもっと見る',
                    head3: '左にスライド してもっと見る',
                    head4: '左にスライド してもっと見る',
                },
            ]
        }
    },
    // 陪跑系列
    accompanyRunSeries: {
        title: 'アカンパニーコース',
        info1: 'トレーニーの実践・実行に長期間コミットするプログラム。実行条件が整っていなかったり、コーチのコミットを必要とするチーム・組織に適しています。戦略・組織・財務・人的資源などに関する指導、個別対応型社内研修、理論と実践の融合によって、企業が無駄なく成果をあげ、成長ボトルネックを解消するサポートをします。',
        projectList: {
            item1: {
                projectText: {
                    title: 'ストラテジックコーチ・アカンパニープログラム',
                    info: '「ヒト・モノ・カネ」の課題を抱える企業チーム',
                },
                projectInfo: {
                    title1: '戦略策定から実行までの',
                    title2: 'クローズドループを実現し、勝てるチームを作る',
                }
            },
            item2: {
                projectText: {
                    title: '90日間組織変革',
                    info: '経営上の特定の課題の解決を目指す企業チーム',
                },
                projectInfo: {
                    title1: '目標を達成して成果をあげ、',
                    title2: '組織の迅速な成長につなげる',
                }
            },
            item3: {
                projectText: {
                    title: 'ボスム・ライトハウスプラン',
                    info: '管理でさらなるブレークスルーを目指す創業者',
                },
                projectInfo: {
                    title1: '成果をあげた人から学び、',
                    title2: '業界のリーダーとなる',
                }
            },
        },
        table: {
            header: {
                head1: 'プログラム名',
                head2: 'ストラテジックコーチ・アカンパニープログラム',
                head3: '90日間で組織を変革する',
                head4: 'ボスム・ライトハウスプラン',
            },
            data: [
                {
                    head1: '対象者',
                    head2: '創業者・上級管理職など',
                    head3: '創業者・上級管理職など',
                    head4: '創業者',
                },
                {
                    head1: 'ペインポイント',
                    head2: '企業運営プロセスにおける「ヒト・モノ・カネ」の課題',
                    head3: ["1.組織にまとまりがない", "2.目標を達成できない",],
                    head4: ["1.成長のボトルネックにはまり込んでいる", "2.管理上の課題が山積している", "3.経営が次第に複雑化している", "4.社員の能力がなかなか伸びない",],
                },
                {
                    head1: 'コース目標',
                    head2: ["戦略策定から実行までのクローズドループを実現し、次の目標を達成する", "1.飛躍的な成果をあげる", "2.実行可能なフォローアップ制度を構築する", "3.効果的なチームインセンティブツールを確立する", "4.勝てるチーム文化を作る",],
                    head3: ["1.適切なコア業務目標を設定する", "2.インセンティブ制度を設計する", "3.目標を達成して成果をあげる",],
                    head4: ["1.実践経験を学び、失敗を回避する", "2.企業の成長のブレークスルー上の課題を解消する", "3.企業産業リソースチェーンを連携する",],
                },
                {
                    head1: 'コース内容',
                    head2: '「ストラテジックコーチ・アカンパニープログラム」',
                    head3: '「90日間組織変革トレーニングキャンプ」',
                    head4: ['「ボスム・ライトハウスプラン 薄連明-企業のブレークスルー」', '「ボスム・ライトハウスプラン 衛哲-成長のブレークスルー'],
                },
                {
                    head1: '受講期間',
                    head2: '6ヶ月',
                    head3: '3ヶ月',
                    head4: '6ヶ月',
                },
                {
                    head1: '受講場所',
                    head2: '全国',
                    head3: '全国',
                    head4: '深圳・上海',
                },
                {
                    head1: '受講料金',
                    head2: '79.8万元',
                    head3: '49.8万元',
                    head4: '19.8万元',
                },
                {
                    head1: '資料ダウンロード',
                    head2: '左にスライド してもっと見る',
                    head3: '左にスライド してもっと見る',
                    head4: '左にスライド してもっと見る',
                },
            ]
        },
        projectList2: {
            item1: {
                projectText: {
                    title: '財務アカンパニープログラム',
                    info: '財務制度の構築による事業運営と財務管理 の融合を目指す企業チーム',
                },
                projectInfo: {
                    title1: '財務データを企業の',
                    title2: '発展の支えとする',
                }
            },
            item2: {
                projectText: {
                    title: '販売アカンパニープログラム',
                    info: '業績拡大上のボトルネックを抱える企業チーム',
                },
                projectInfo: {
                    title1: '販売上のボトルネックを解消し、',
                    title2: '業績を長期的持続的に拡大する',
                }
            },
            item3: {
                projectText: {
                    title: '人的資源アカンパニープログラム',
                    info: '人材の採用・育成・活用上の課題を抱える企業チーム',
                },
                projectInfo: {
                    title1: '人材の優位性を効果的に賦活させ、',
                    title2: '組織力を全面的に向上させる',
                }
            },
            item4: {
                projectText: {
                    title: '個別対応型社内研修',
                    info: '社全体の管理水準と社員の専門的能力の向上を目指す企業チーム',
                },
                projectInfo: {
                    title1: '社の経営管理水準と社員の',
                    title2: '資質を向上させる',
                }
            },
        },
        table2: {
            header: {
                head1: 'プログラム名',
                head2: '財務アカンパニープログラム',
                head3: '販売アカンパニープログラム',
                head4: '人的資源アカンパニープログラム',
                head5: '個別対応型社内研修',
            },
            data: [
                {
                    head1: '対象者',
                    head2: '創業者・財務チーム',
                    head3: '企業トップ+営業チーム',
                    head4: '企業トップ+人事責任者+経営幹部',
                    head5: '企業コアチーム',
                },
                {
                    head1: 'ペインポイント',
                    head2: ["1.社員と企業トップの考えが食い違っている", "2.財務システムにリスクがある", "3.企業がなかなか成長できない",],
                    head3: ["1.販売プロセスを欠いている", "2.販売管理が混乱している", "3.販売人材を育成できない",],
                    head4: ["1.ポジションにふさわしい人材が集まらない", "2.人材成長スピードが遅い", "3.人事業務効率が低く、アウトプットに影響が及んでいる",],
                    head5: ["1.外部機関・講師をどう選んでいいか分からない", "2.コース体験・研修効果を制御できない", "3.効果的な人材育成計画を策定できない",],
                },
                {
                    head1: 'コース目標',
                    head2: ["1.チームの共感・共鳴を実現する", "2.財務管理システムを構築し、リスクを管理する", "3.収益を持続的に生み出す",],
                    head3: ["1.独自の販売プロセスを手にする", "2.効果的な販売ツールを獲得する", "3.一流の営業チームを構築する",],
                    head4: ["1.人材の優位性を賦活させる", "2.人材育成・インセンティブシステムを確立する", "3.組織力を向上させる",],
                    head5: ["1.企業の現状と社員を評価分析する", "2.トレーニー・組織の全面的な成長を支援する",],
                },
                {
                    head1: 'コース内容',
                    head2: ["「ポスト・エグゼクティブ財務管理システム」", "「事業運営と財務管理の融合アカンパニープログラム」",],
                    head3: '「勝てる営業アカンパニープログラム」',
                    head4: '「組織力向上アカンパニープログラム」',
                    head5: ["「管理アカンパニープログラム」", "「チームアカンパニープログラム」", "「専門性向上コース」", "「社員全体資質向上コース」",],
                },
                {
                    head1: '受講期間',
                    head2: '3-6ヶ月',
                    head3: '3～12ヶ月',
                    head4: '3ヶ月',
                    head5: '詳細はお問い合わせください',
                },
                {
                    head1: '受講場所',
                    head2: '全国',
                    head3: '全国',
                    head4: '全国',
                    head5: '全国',
                },
                {
                    head1: '受講料金',
                    head2: '詳細はお問い合わせください',
                    head3: '詳細はお問い合わせください',
                    head4: '詳細はお問い合わせください',
                    head5: '詳細はお問い合わせください',
                },
                {
                    head1: '資料ダウンロード',
                    head2: '左にスライド してもっと見る',
                    head3: '左にスライド してもっと見る',
                    head4: '左にスライド してもっと見る',
                    head5: '左にスライド してもっと見る',
                },
            ]
        }
    },
    // 领跑系列
    lead: {
        title: 'リーダーコース',
        info1: 'リーダーコースには、企業運営管理専門コンサルティング・オウンドメディア専門コンサルティングが含まれます',
        info2: '企業運営管理専門コンサルティング：ある程度の規模があり、さらなるブレークスルー・ステップアップを目指す企業に適しています。運営効率、組織力、販売管理、財務コンプライアンス、年間財務・税務コンサルティングによって、企業が賦活力を保ち、事業基盤を守り、業界のリーダーとなる支援をします。',
        info3: 'オウンドメディア専門コンサルティング：ニューメディア・ショート動画・ライブ配信などの分野でのブレークスルーを目指す企業CEO・意思決定者・事業責任者に適しています。コンテンツ・ポジショニング、バズ動画テンプレート、チーム構築などによって、企業のライブ配信・ショート動画のあらゆるプロセスの課題を解決し、変革の先駆者となることを支援します。',
        info4: "企業運営管理専門コンサルティング",
        info5: "オウンドメディア専門コンサルティング",
        projectList: {
            item1: {
                projectText: {
                    title: '運営効率高度化',
                    info: 'システムの構築による経営クローズドループの実 現を目指す企業',
                },
                projectInfo: {
                    title1: '内部効率を向上させ、企業の',
                    title2: '持続的成長を支援する',
                }
            },
            item2: {
                projectText: {
                    title: '組織力向上',
                    info: '合理的な組織発展モデルの確立による経営目標の 達成を目指す企業',
                },
                projectInfo: {
                    title1: 'チームをエンパワーメントし、',
                    title2: '組織パフォーマンスの向上を支援する',
                }
            },
            item3: {
                projectText: {
                    title: '販売管理システム構築',
                    info: '販売システムの標準化、勝てる営業チームの確 立を目指す企業',
                },
                projectInfo: {
                    title1: '持続的な成約を可能にする ',
                    title2: '販売管理システムを構築する',
                }
            },
        },
        table: {
            header: {
                head1: 'プログラム名',
                head2: '運営効率高度化コンサルティング',
                head3: '組織力向上コンサルティング',
                head4: '販売管理システム構 築コンサルティング',
            },
            data: [
                {
                    head1: '対象者',
                    head2: '企業チーム',
                    head3: '企業チーム',
                    head4: '企業チーム',
                },
                {
                    head1: 'ペインポイント',
                    head2: ["1.管理が機能していない / 活用可能な人材がいない", "2.ボトルネックが顕在化している / インセンティブが機能していない", "3.責任・権限があいまいである / 目標があいまいである",],
                    head3: ["1.中・上級管理職の考え方・意見が統一されておらず、社内衝突が生じている", "2.社員の業務効率が低下しており、企業トップも社員も忙しいわりにパフォーマンスにつながっていない", "3.管理職・社員に責任感が欠如しており、互いに責任を転嫁している", "4.管理職が後進を育てようとせず、人材に乏しい",],
                    head4: ["1.販売計画が進まない", "2.販売交渉が難しい", "3.適当な販売ツールがない",],
                },
                {
                    head1: 'プログラム目標',
                    head2: ["1.システムを構築する", "2.組織を強化する", "3.ボトルネックを解消する",],
                    head3: ["1.経営ビジョンを策定する", "2.上下間の協力を実現する", "3.組織システム基盤を強化する",],
                    head4: ["1.勝てる営業チームを作る", "2.成約拡大システムを構築する", "3.1、2つの主要成約ブレークスルーを実現する",],
                },
                {
                    head1: 'プログラム内容',
                    head2: ["1.経営管理システムの構築", "2.組織運営力の強化", "3.主要経営ボトルネックの解消",],
                    head3: ["1.組織パフォーマンスの賦活", "2.社員モチベーションの向上", "3.社員の能力の高度化",],
                    head4: ["1.戦略・戦術を策定する", "2.貪欲な勝てる営業チームを作る", "3.成約ボトルネックを解消し、業績拡大につなげる",],
                },
                {
                    head1: '受講期間',
                    head2: '6ヶ月',
                    head3: '6ヶ月',
                    head4: '6ヶ月',
                },
                {
                    head1: '受講場所',
                    head2: '全国',
                    head3: '全国',
                    head4: '深圳/上海',
                },
                {
                    head1: '受講料金',
                    head2: '企業の実情に応じて見積もり',
                    head3: '企業の実情に応じて見積もり',
                    head4: '企業の実情に応じて見積もり',
                },
                {
                    head1: '資料ダウンロード',
                    head2: '左にスライド してもっと見る',
                    head3: '左にスライド してもっと見る',
                    head4: '左にスライド してもっと見る',
                },
            ]
        },
        projectList2: {
            item1: {
                projectText: {
                    title: '【財務コンプライアンスコンサルティング】 【年間財務・税務コンサルティング】',
                    info: 'コストの削減・効率化、企業コンプライアンス の実現、事業拡大を目指す企業',
                },
                projectInfo: {
                    title1: '実践的なコンサルティングによって財務',
                    title2: '・税務コンプライアンスを強化する',
                }
            },
            item2: {
                projectText: {
                    title: '销售陪跑',
                    info: '业绩增长遭遇瓶颈的企业团队',
                },
                projectInfo: {
                    title1: '打破企业销售瓶颈',
                    title2: '长期持续提高业绩',
                }
            },
            item3: {
                projectText: {
                    title: '人力陪跑',
                    info: '面临招人难、育人难、用人难的企业团队',
                },
                projectInfo: {
                    title1: '有效激活人才优势',
                    title2: '全面提升组织能力',
                }
            },
            item4: {
                projectText: {
                    title: '定制化企业内训',
                    info: '需提高公司整体管理水平、员工专业能力的企业团队',
                },
                projectInfo: {
                    title1: '提升公司的经营管理水平',
                    title2: '及员工素质',
                }
            },
        },
        projectList4: {
            item1: {
                projectText: {
                    title: 'オウンドメディア専門 コンサルティング',
                    info: 'ショート動画・ライブ配信を 始めようとする企業チーム',
                },
                projectInfo: {
                    title1: '競争の激しいショート動画・ライブ配信事業分野を特定し、',
                    title2: '新たなオンラインマーケティングシナリオを構築する',
                }
            },
            item2: {
                projectText: {
                    title: '销售陪跑',
                    info: '业绩增长遭遇瓶颈的企业团队',
                },
                projectInfo: {
                    title1: '打破企业销售瓶颈',
                    title2: '长期持续提高业绩',
                }
            },
            item3: {
                projectText: {
                    title: '人力陪跑',
                    info: '面临招人难、育人难、用人难的企业团队',
                },
                projectInfo: {
                    title1: '有效激活人才优势',
                    title2: '全面提升组织能力',
                }
            },
            item4: {
                projectText: {
                    title: '定制化企业内训',
                    info: '需提高公司整体管理水平、员工专业能力的企业团队',
                },
                projectInfo: {
                    title1: '提升公司的经营管理水平',
                    title2: '及员工素质',
                }
            },
        },
        table2: {
            header: {
                head1: 'プログラム名',
                head2: '財務コンプライアンスコンサルティング',
                head3: '年間財務・税務コンサルティング',
            },
            data: [
                {
                    head1: '対象者',
                    head2: '企業チーム',
                    head3: '企業チーム',
                },
                {
                    head1: 'ペインポイント',
                    head2: ["1.財務・税務が標準化されておらず、リスクがある", "2.コストが高く、利益が少ない",],
                    head3: ["1.財務諸表が事業意思決定の参考にならない", "2.最新の税務政策を理解できていない", "3.財務担当者の専門性が不足している",],
                },
                {
                    head1: 'プログラム目標',
                    head2: ["1.企業リスクを可視化する", "2.政策に基づいてコンプライアンスを改善する", "3.企業納税構造コンプライアンスを最適化する", "4.諸表社内精査リスクを制御可能にする", "5.支出証憑コンプライアンス・資金コンプライアンスを改善する", "6.企業コストを削減し、利益を増大させる",],
                    head3: ["1.企業リスクを可視化する", "2.財務チームを構築し、事業運営と財務管理を融合する", "3.資金コンプライアンスを改善し、適切に配分する", "4.各意思決定をデータ根拠に基づくものとする", "5.自社に適した財務担当者を育成する", "6.合法的な節税を行い、社の資産の安全性を確保する", "7.正確な見積もりを行い、コスト削減・効率化につなげる", "8.一族の資産を無事継承し、維持・増大させる",],
                },
                {
                    head1: 'プログラム内容',
                    head2: ["1.社内健康診断の報告", "2.これまでの課題の整理", "3.トップダウン構造の設計", "4.企業税務計画 ", "5.財務諸表の監査",],
                    head3: ["1.財務支援システムの構築", "2.管理報告システムの構築", "3.会計計算システムの構築", "4.資金管理システムの構築", "5.財務分析システムの構築", "6.財務管理制度の確立", "7.税務管理システムの構築", "8.財務チーム専門性の確立",],
                },
                {
                    head1: '受講期間',
                    head2: '6ヶ月',
                    head3: '12ヶ月',
                },
                {
                    head1: '受講場所',
                    head2: '全国',
                    head3: '全国',
                },
                {
                    head1: '受講料金',
                    head2: '69.98万元',
                    head3: '100万元',
                },
                {
                    head1: '資料ダウンロード',
                    head2: '左にスライド してもっと見る',
                    head3: '左にスライド してもっと見る',
                },
            ]
        },
        projectList3: {
            item1: {
                projectText: {
                    title: '战略教练陪跑项目',
                    info: '经营面临人、财、物困扰的企业团队',
                },
                projectInfo: {
                    title1: '实现从战略到执行的闭环',
                    title2: '打造一个能打胜仗的团队',
                }
            },
            item2: {
                projectText: {
                    title: '引爆组织90天',
                    info: '需要单点解决某个经营问题的企业团队',
                },
                projectInfo: {
                    title1: '突破目标拿到结果',
                    title2: '引爆组织快速增长',
                }
            },
            item3: {
                projectText: {
                    title: '博商·灯塔计划',
                    info: '在管理上无法获得进一步突破的创始人',
                },
                projectInfo: {
                    title1: '跟更有结果的人学习',
                    title2: '成为行业的先锋',
                }
            },
        },
        table3: {
            header: {
                head1: 'プログラム名',
                head2: '創美ショート動画マーケティングコンサルティングリーダーコース',
                head3: '創美ライブ配信マーケティングコンサルティングリーダーコース',
                head4: '創美ショート動画・ライブ配信マーケティングコンサルティングリーダーコース',
            },
            data: [
                {
                    head1: '対象者',
                    head2: '企業CEO・事業責任者',
                    head3: '企業CEO・事業責任者',
                    head4: '企業CEO・事業責任者',
                },
                {
                    head1: 'ペインポイント',
                    head2: ["1.ショート動画のマーケティング手法が分からない", "2.コンテンツ・ポジショニングがあいまいである", "3.配信ロジックが分からない",],
                    head3: ["1.ライブ配信視聴回数増加手法が分からない", "2.トラフィック・コンバージョン拡大のノウハウがない", "3.配信チームの専門性が不足している",],
                    head4: ["1.ショート動画をどう始めていいか分からない", "2.ライブ配信をどう始めていいか分からない",],
                },
                {
                    head1: 'コース目標',
                    head2: ["1.ショート動画公式アカウントのポジショニングを明確にする", "2.コンテンツの相違点を見つける", "3.トラフィックの収益化を実現する",],
                    head3: ["1.自社に適したライブ配信モデルを選択する", "2.ライブ配信中のトラフィック・コンバージョンを拡大する", "3.プロフェッショナルな配信チームを構築する",],
                    head4: ["1.適切なプラットフォームを選択する","2.ポジショニングを明確にする","3.トラフィックを収益化する",],
                },
                // {
                //   head1: 'プログラム内容',
                //   head2: ['1. 建运营管控系统', '2. 强组织运营能力', '3. 破核心经营瓶颈'],
                //   head3: ['1. 激活组织绩效', '2. 点燃人才动力', '3. 升级人才能力'],
                //   head4: ['1. 谋定全局、排兵布阵', '2. 打造“狼性”销售铁军', '3. 破成交瓶颈，促业绩提升'],
                // },
                {
                    head1: '受講期間',
                    head2: '3ヶ月',
                    head3: '3ヶ月',
                    head4: '3ヶ月',
                },
                {
                    head1: '受講場所',
                    head2: '全国',
                    head3: '全国',
                    head4: '全国',
                },
                {
                    head1: '受講料金',
                    head2: '29.8万',
                    head3: '29.8万',
                    head4: '49.8万',
                },
                {
                    head1: '資料ダウンロード',
                    head2: '左にスライド してもっと見る',
                    head3: '左にスライド してもっと見る',
                    head4: '左にスライド してもっと見る',
                },
            ]
        },

    },
    onLine: {
        title: 'オンラインコース',
        info1: '当社のeラーニングプラットフォーム「ウィート」は、スキマ時間を活用していつでもどこでも学習したいアントレプレナーや管理職に適しています。「ビジネスモデル」「株主構成設計」「財務・税務管理」「収益拡大」「販売管理」など、実践を経た10の管理方法論に関する厳選されたコース内容を録画した180本以上の動画を見て学ぶことで、管理に対する認識を深め、手法を身につけ、実践へとつなげることが可能となります。',
        info2:"いつでもどこ",
        info3:"でも学習可能",
        info4:"実践で検証さ",
        info5:"れたコース",
        info6:"すぐに実践に応用可能",
        info7:"ボスム「ウィート」でもっと多くのコースを見る",
        projectList: {
            item1: {
                projectText: {
                    title: '博商小麦アプリ',
                    info: 'まとまった時間をとれない起業家・ビジネスエリート',
                },
                projectInfo: {
                    title1: '100名以上のプラクティカルメンタ',
                    title2: 'ーの指導で無駄なく管理手法を向上',
                }
            },
        },
    },
    // 团队共学研习社
    teamLearnTrainSociety: {
        title: 'グループ学習クラスコース',
        info1: 'マーケット・効率・リソース・モデルのブレークスルーにフォーカスした短期集中コース。チームとしてともに学ぶことで、特定の垂直分野の能力の向上を目指すチーム・組織の実行力・チームコアコンピタンス強化を支援し、社の全体的発展を促進します。',
        projectList: {
            item1: {
                projectInfo: {
                    title: 'マーケットのブレークスルー',
                    info: '',
                },
                projectText: [
                    {
                        title: 'マーケティングシステム：',
                        text: 'カテゴリNO.1事業を作るためのマーケティング方法論を紐解く'
                    },
                    {
                        title: 'ニューメディアマーケティング：',
                        text: 'ニューメディアマーケティング手法を解読し、ショート動画ラ イブ配信からのリピートを増やし、トラフィックからの顧客獲 得力を強化する'
                    },
                    {
                        title: '販売管理：',
                        text: '大口顧客成約率と営業チーム成績管理を向上させる'
                    },
                ]
            },
            item2: {
                projectInfo: {
                    title: '効率のブレークスルー',
                    info: '',
                },
                projectText: [
                    {
                        title: '組織人材：',
                        text: '組織の発展の基盤を築き、人材管理制度を賦活させ、 組織の潜在的シナジーを顕在化させる'
                    },
                    {
                        title: '経営管理：',
                        text: '経営管理システムを構築し、人への依存を管理・プロ セスへの依存に移行する'
                    },
                ]
            },
            item3: {
                projectInfo: {
                    title: 'リソースのブレークスルー',
                    info: '在管理上无法获得进一步突破的创始人',
                },
                projectText: [
                    {
                        title: '財務・税務コスト管理：',
                        text: '税務リスクを回避し、合法的な節税を行い、資金回転率を向上 させ、財務・税務支援業務リソースのバリューを生み出す'
                    },
                    {
                        title: '株主構成設計：',
                        text: '株主構成リスクを回避し、適切なインセンティブを設計し、富 の配分により人を集め、企業リソースを高度化する'
                    },
                    {
                        title: '資本調達：',
                        text: '企業の投融資上の課題を解決し、外部リソースを獲得し、企業の 成長を加速する'
                    },
                ]
            },
            item4: {
                projectInfo: {
                    title: 'モデルのブレークスルー',
                    info: '在管理上无法获得进一步突破的创始人',
                },
                projectText: [
                    {
                        title: 'ビジネスモデル：',
                        text: 'ビジネスモデルを整理診断し、収益にフォーカスして突破 口を見つける'
                    },
                    {
                        title: '戦略：',
                        text: '産業バリューチェーンのブレークスルーポイントを探し、コ アコンピタンスを掘り起こす'
                    },
                ]
            },
        },
        table: {
            header0: {
                head1: 'プログラム名',
                head2: 'マーケットのブレークスルー',
            },
            header: {
                head1: '内容',
                head2: 'マーケティングシステム',
                head3: 'ニューメディアマーケティング',
                head4: '販売管理',
            },
            data: [
                {
                    head1: '対象者',
                    head2: '創業者パートナー+ブランド・マーケティング責任者',
                    head3: '創業者パートナー+ニューメディア事業担当者',
                    head4: '創業者パートナー+最高販売責任者',
                },
                {
                    head1: 'ペインポイント',
                    head2: ["1.マーケティングに対する全般的な認識を欠いている", "2.多元化によってブランドデザイン、ヒット商品創出を進めている",],
                    head3: ["1.ニューメディアに対する認識が不足している", "2.トラフィックのマネタイズ・コンバージョン力がない", "3.顧客獲得コストが高く、価格競争を迫られている",],
                    head4: ['1. 企業トップに業務チームの成績管理に対する認識が不足している', '2. 営業チームtの戦闘力が不足している'],
                },
                {
                    head1: 'コース目標',
                    head2: ['1. 体系的なマーケティング手法を身につける', '2. ヒット商品を模索し、ブランドを強化し、価格プレミアムを実現する'],
                    head3: ['1. トラフィック拡大手法を身につけ、ショート動画・ライブ配信事業を推進する', '2. オウンドメディアのトラフィックを増やし、リテンション・リピートを促進する'],
                    head4: ['1. メンターの実践経験から学び、中小企業に適した販売管理手法へと移行する', '2. 大口顧客成約率と営業チーム成績管理を向上させる'],
                },
                {
                    head1: '最新コース',
                    head2: '「F8マーケティングシステムで勝つ」',
                    head3: ["「ショート動画で勝つ」", "「ライブ配信で勝つ」", "「オウンドメディアで勝つ」", "「ローカルライフで勝つ」",],
                    head4: '「販売で勝つ」',
                },
                {
                    head1: '受講期間',
                    head2: '2～3日（コースごとに異なる）',
                    head3: '2～3日（コースごとに異なる）',
                    head4: '2～3日（コースごとに異なる）',
                },
                {
                    head1: '受講推奨人数',
                    head2: '2名以上',
                    head3: '2名以上',
                    head4: '2名以上',
                },
                {
                    head1: '受講場所',
                    head2: '全国',
                    head3: '全国',
                    head4: '全国',
                },
                {
                    head1: '受講料金',
                    head2: 'コース内容によって異なる（詳細は資料をご確認ください）',
                    head3: 'コース内容によって異なる（詳細は資料をご確認ください）',
                    head4: 'コース内容によって異なる（詳細は資料をご確認ください）',
                },
                {
                    head1: '資料ダウンロード',
                    head2: '左にスライド してもっと見る',
                    head3: '左にスライド してもっと見る',
                    head4: '左にスライド してもっと見る',
                },
            ]
        },
        table2: {
            header0: {
                head1: 'プログラム名',
                head2: '効率のブレークスルー',
            },
            header: {
                head1: '内容',
                head2: '組織人材',
                head3: '経営管理',
            },
            data: [
                {
                    head1: '対象者',
                    head2: '創業者パートナー+最高人事責任者など上級管理職',
                    head3: '創業者パートナー+プロフェッショナルマネージャー（中・上級管理職）',
                },
                {
                    head1: 'ペインポイント',
                    head2: ["1.組織改革がなかなか進まない", "2.人材をなかなか採用・活用・育成・維持できない", "3.組織内の求心力・モチベーションが不足している",],
                    head3: ['1.組織運営・生産・納品などの各プロセスの効率が低下している', '2.企業の経営目標があいまいで、目標を実践できない'],
                },
                {
                    head1: 'コース目標',
                    head2: ["1.人材の育成・採用などをめぐる課題を解決する", "2.企業文化を効果的に構築し、実践する", "3.インセンティブ制度を設計し、チームのシナジーを顕在化させる",],
                    head3: ['制度・プロセス管理人材を育成し、', '企業運営管理システムのクローズドループを構築する'],
                },
                {
                    head1: '最新コース',
                    head2: ["「人材で勝つ」（独自）", "「組織進化で勝つ」", "「パフォーマンスで勝つ」", "「勝てるチーム」（独自",],
                    head3: ['「プロセスで勝つ：プロセスのコピーで成功する」', '「運営で勝つ」 ', '「組織力を引き出す」'],
                },
                {
                    head1: '受講期間',
                    head2: '2～3日（コースごとに異なる）',
                    head3: '2～3日（コースごとに異なる）',
                },
                {
                    head1: '受講推奨人数',
                    head2: '2名以上',
                    head3: '2名以上',
                },
                {
                    head1: '受講場所',
                    head2: '全国',
                    head3: '全国',
                },
                {
                    head1: '受講料金',
                    head2: 'コース内容によって異なる（詳細は資料をご確認ください）',
                    head3: 'コース内容によって異なる（詳細は資料をご確認ください）',
                },
                {
                    head1: '資料ダウンロード',
                    head2: '左にスライド してもっと見る',
                    head3: '左にスライド してもっと見る',
                },
            ]
        },
        table3: {
            header0: {
                head1: 'プログラム名',
                head2: 'リソースのブレークスルー',
            },
            header: {
                head1: '内容',
                head2: '財務・税務コスト管理',
                head3: '株主構成設計',
                head4: '資本調達',
            },
            data: [
                {
                    head1: '対象者',
                    head2: '創業者+最高財務責任者など意思決定者',
                    head3: '企業CEO・社長などの意思決定者',
                    head4: '創業者パートナーなどの意思決定者',
                },
                {
                    head1: 'ペインポイント',
                    head2: ["1.キャッシュフローがうまく回らない", "2.株主構成が適切でない", "3.税務を理解できておらず、払い過ぎ・払い漏れがある", "4.コストが高く、利益が少ない",],
                    head3: ["1.株主構成があいまいで縁故主義によっている", "2.企業構造が標準化されておらず、リスクがある", "3.社員のモチベーションが低く、効率に影響が及んでいる", "4.株主構成の変動が企業の上場に影響を及ぼしている",],
                    head4: ['1.投融資の意思はあるものの、糸口が全くつかめない', '2.融資がなかなか進まない'],
                },
                {
                    head1: 'コース目標',
                    head2: ["1.資金回転率を向上させる", "2.株主構成・取引構造を見直す", "3.適切かつ合法的な節税を行う", "4.コストを効果的に管理し、利益を増大させる",],
                    head3: ["1.株主構成を適切に規定し、リスクを回避する", "2.インセンティブ・パートナー制度を設計する", "3.株主との利益共有・リスク分担を実現する", "4.上場に向けて社の成長を加速する",],
                    head4: '投融資上の課題の解決を支援する',
                },
                {
                    head1: '最新コース',
                    head2: ['「財務で勝つ」', '「税務で勝つ」'],
                    head3: ["「インセンティブストックオプションで勝つ」", "「エクイティシステムで勝つ」", "「エクイティモデルで勝つ」",],
                    head4: '「キャピタルで勝つ」',
                },
                {
                    head1: '受講期間',
                    head2: '2～3日（コースごとに異なる）',
                    head3: '3天2晚',
                    head4: '2～3日（コースごとに異なる）',
                },
                {
                    head1: '受講推奨人数',
                    head2: '2名以上',
                    head3: '2名以上',
                    head4: '2名以上',
                },
                {
                    head1: '受講場所',
                    head2: '全国',
                    head3: '全国',
                    head4: '全国',
                },
                {
                    head1: '受講料金',
                    head2: 'コース内容によって異なる（詳細は資料をご確認ください）',
                    head3: 'コース内容によって異なる（詳細は資料をご確認ください）',
                    head4: 'コース内容によって異なる（詳細は資料をご確認ください）',
                },
                {
                    head1: '資料ダウンロード',
                    head2: '左にスライド してもっと見る',
                    head3: '左にスライド してもっと見る',
                    head4: '左にスライド してもっと見る',
                },
            ]
        },
        table4: {
            header0: {
                head1: 'プログラム名',
                head2: 'モデルのブレークスルー',
            },
            header: {
                head1: '内容',
                head2: 'ビジネスモデル',
                head3: '戦略',
            },
            data: [
                {
                    head1: '',
                    head2: ['オンライン：ビジネスモデルトレーニングキャンプ さ', 'らに多くのオフラインコース 乞うご期待'],
                    head3: 'さらに多くのオフラインコース 乞うご期待',
                },
            ]
        },
    },

}


// WEBPACK FOOTER //
// ./src/lang/class/ja.js